import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

const TandCModal = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const modalData = useSelector(state => state.tandcModalData);
	const { open, form_component, lang } = modalData;

	useEffect(() => {
		if (open) {
			const formElement = document.querySelector('.form');
			if (formElement) {
				formElement.style.zIndex = '102';
			}
		}
	}, [open]);

	const handleClose = () => {
		const payload = {
			...modalData,
			open: false
		};

		dispatch({type: 'SET_TANDC_MODAL_DATA', payload: payload});
	}

	if (!open || !form_component) {
		return null;
	}

	const tandcContent = form_component.tandc_content;
	if (!tandcContent) {
		return null;
	}

	let contentHtml = null;
	if (tandcContent[lang]) {
		contentHtml = tandcContent[lang];
	} else if (tandcContent.tc) {
		contentHtml = tandcContent.tc;
	} else if (typeof tandcContent === 'string') {
		contentHtml = tandcContent;
	} else {
		const firstKey = Object.keys(tandcContent)[0];
		if (firstKey) {
			contentHtml = tandcContent[firstKey];
		}
	}

	if (!contentHtml) {
		return null;
	}

	return (
		<Modal
			show={open}
			onHide={handleClose}
			size="lg"
			backdrop="static"
			scrollable
		>
			<Modal.Header closeButton>
				<Modal.Title>條款內容</Modal.Title>
			</Modal.Header>
			<Modal.Body style={{maxHeight: '70vh', overflowY: 'auto'}}>
				<div dangerouslySetInnerHTML={{__html: contentHtml}}></div>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={handleClose}>{t('關閉')}</Button>
			</Modal.Footer>
		</Modal>
	);
}

export default TandCModal;
